import { Box, Stack, Typography, useTheme } from "@mui/material";
import ButtonComponent from "../../components/form/buttonComponent";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const FileNotFound = ({
    icon,
    description,
    actionText,
    navigateLink
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const navigate = useNavigate();

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    py: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <Box
                        width={150}
                        height={150}
                    >
                        <img 
                            src={icon}
                            alt="file" 
                            width='100%' 
                        />
                    </Box>

                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, lg: 16}}
                        textAlign="center"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                        sx={{
                            pt: {xs: 0, md: 6},
                            pb: {xs: 2, md: 5}
                        }}
                    >
                        {description}
                    </Typography>

                    <ButtonComponent 
                        label={actionText}
                        onClick={() => {
                            navigate(navigateLink);
                        }}
                    />
                </Stack>
            </Box>
        </>
    );
}

export default FileNotFound;